import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl  } from '@angular/platform-browser';
import { AccountServiceProvider } from '../../providers/account-service/account-service';
import { Shareddata } from '../../providers/shareddata';
import * as abc from 'src/assets/js/masonry.pkgd.min.js';
import Masonry from 'masonry-layout';
import * as imagesLoaded from 'src/assets/js/imagesloaded.pkgd.min.js';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/interval';

@Component({
	selector      : 'app-social-media',
	templateUrl   : './social-media.component.html',
	encapsulation : ViewEncapsulation.None,
	host: {
		'(window:resize)': 'onResize($event)'
	}
})

export class SocialMediaComponent implements OnInit {
	@Input() socialMediaData : any;
	public mediaData                  : any;
	public currentSwedishTime         : any;
	public showVideoTimeInterval      : any;
	public showVideoTimeIntervalArray : any = [];
	public videoUrlType               : any;
	public observableRef2             : any;
	public observableRef3             : any;
	public showVideo : boolean = false;	
	public videoUrl?: SafeUrl;	

	constructor(
		private sanitizer      : DomSanitizer,
		private accountService : AccountServiceProvider,
		public shareddata      : Shareddata,
	) {
		var event = new Date().getTime();
		var swedish_time = event + 7200000;
		var swedish_hour = Math.floor((swedish_time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		var swedish_minutes = Math.floor((swedish_time % (1000 * 60 * 60)) / (1000 * 60));
		this.currentSwedishTime = swedish_hour + ':' + swedish_minutes;
		this.accountService.getLiveMedia().then( ( dotnetresponse: any ) => {
			if ( 'Ok' == dotnetresponse.status ) {
				this.mediaData = dotnetresponse.sessionLiveMedia;
				if ( this.mediaData != '' ) {
					this.showVideoTimeInterval = this.mediaData[0].timeInterval;
					this.showVideoTimeIntervalArray = this.showVideoTimeInterval.split( '-' );
					if ( this.currentSwedishTime > this.showVideoTimeIntervalArray[0] || this.currentSwedishTime < this.showVideoTimeIntervalArray[1] ) {
						this.showVideo = true;
						this.videoUrlType = this.mediaData[0].liveStreamProvider;
						if ( 'vimeo' == this.videoUrlType ) {
							let url = this.mediaData[0].liveStreamLink.split(/[/]+/).pop();
							url = 'https://player.vimeo.com/video/' + url + '?autoplay=1';
							this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl( url );
						} else {
							let url = 'https://www.facebook.com/plugins/video.php?href=' + this.mediaData[0].liveStreamLink;
							this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl( url );
						}
						this.shareddata.setVideoView( true );
						this.shareddata.setVideoUrl( this.videoUrl );
					} else {
						this.observableRef2 = Observable.interval( 60000 ).subscribe( x => {
							if ( this.currentSwedishTime == this.showVideoTimeIntervalArray[0] ) {
								this.videoUrlType = this.mediaData[0].liveStreamProvider;
								if ( 'vimeo' == this.videoUrlType ) {
									let url = this.mediaData[0].liveStreamLink.split(/[/]+/).pop();
									url = 'https://player.vimeo.com/video/' + url + '?autoplay=1';
									this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl( url );
								} else {
									let url = 'https://www.facebook.com/plugins/video.php?href=' + this.mediaData[0].liveStreamLink;
									this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl( url );
								}
								this.shareddata.setVideoView( true );
								this.shareddata.setVideoUrl( this.videoUrl );
							}
						});
					}
					this.observableRef3 = Observable.interval( 60000 ).subscribe( x => {
						if ( this.currentSwedishTime > this.showVideoTimeIntervalArray[0] || this.currentSwedishTime < this.showVideoTimeIntervalArray[1] )
							this.shareddata.setVideoView( true );
						else
							this.shareddata.setVideoView( false );
					});					
					var groupByInterval = {};
					this.mediaData.forEach( function( a, b ) {
						groupByInterval [ a.eventDate ] = groupByInterval [ a.eventDate ] || [];
						groupByInterval [ a.eventDate ].push({ val : a });
					});
					var myArray = Object.keys( groupByInterval ).map( function( key ){
						var interval_arr = key.split( '|' );
					    
					    return { interval: key, values: groupByInterval[ key ] };
					});
					this.mediaData = myArray;
				}
			} else
				this.shareddata.setVideoView( false );
		});
	}

	ngOnDestroy() {
		if ( this.observableRef2 )
			this.observableRef2.unsubscribe();
		if ( this.observableRef3 )
			this.observableRef3.unsubscribe();
	}

	ngOnInit() {}

	onResize(event) {}
}